type Period = '30d' | '90d' | '6m' | '1y';

interface PeriodSelectorProps {
  value: Period;
  onChange: (next: Period) => void;
}

const OPTIONS: { id: Period; label: string }[] = [
  { id: '30d', label: '30 dias' },
  { id: '90d', label: '90 dias' },
  { id: '6m', label: '6 meses' },
  { id: '1y', label: '1 ano' },
];

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  return (
    <div className="inline-flex bg-subtle rounded-lg p-1 gap-1">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          onClick={() => onChange(o.id)}
          className={`text-xs px-3 py-1 rounded-md transition-colors ${
            value === o.id
              ? 'bg-surface text-ink-primary shadow-sm'
              : 'text-ink-secondary hover:text-ink-primary'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export type { Period };
